import React from 'react';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';

import ArrowDownIcon from 'assets/icons/arrow-down.svg';

import classes from './FAQSection.module.scss';
const FAQSection = () => {
    const accordionStyle = {
        '& p': {
            fontSize: '18px',
            fontWeight: 700
        },
        '&.Mui-expanded': {
            color: '#BB3A90'
        }
    };

    return (
        <div className={`${classes['wrapper']} d-xl-block d-none`}>
            <div className='container py-5 '>
                <div className="row d-flex justify-content-center py-5">
                    <div className="col-12 col-xl-10">
                        <h2>FAQs</h2>
                        <Accordion className={classes['item']}>
                            <AccordionSummary
                                expandIcon={<ArrowDownIcon />}
                                sx={accordionStyle}
                            >
                                <Typography>What is included?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Our subscription plans offer access to a wide range of high-quality courses across
                                    various topics, please see the subscription plans for more information.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion className={classes['item']}>
                            <AccordionSummary
                                expandIcon={<ArrowDownIcon />}
                                sx={accordionStyle}
                            >
                                <Typography>How do I subscribe? </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    To subscribe, navigate to the Subscriptions page, and select either the monthly or
                                    yearly plan. Follow the instructions to complete your subscription.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion className={classes['item']}>
                            <AccordionSummary
                                expandIcon={<ArrowDownIcon />}
                                sx={accordionStyle}
                            >
                                <Typography>Can I switch between monthly and yearly plans? </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Currently, you can only switch from monthly to yearly plans.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion className={classes['item']}>
                            <AccordionSummary
                                expandIcon={<ArrowDownIcon />}
                                sx={accordionStyle}
                            >
                                <Typography>What is the cost of the monthly or yearly subscription?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    The cost of the monthly or yearly subscription varies based on your location and
                                    any current promotions. Please check the Subscriptions page for the latest pricing.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion className={classes['item']}>
                            <AccordionSummary
                                expandIcon={<ArrowDownIcon />}
                                sx={accordionStyle}
                            >
                                <Typography>Can I cancel my subscription? </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Yes, you can cancel your subscription at any time. Your access will continue until
                                    the end of your current billing cycle. Please refer to our terms and conditions.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion className={classes['item']}>
                            <AccordionSummary
                                expandIcon={<ArrowDownIcon />}
                                sx={accordionStyle}
                            >
                                <Typography>How is the payment processed for the subscriptions? </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Payments are processed automatically on the same date for each billing cycle. For example, if you sign up for
                                    a monthly subscription on the 01st of the month, then the next billing will be the 01st of the following month.
                                    For yearly subscriptions, the same process applies and you will be automatically charged in your next billing cycle.
                                    For example, if you sign up for a yearly subscription on the 01st January 2024 your next payment to be process will be 01st January 2025.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQSection;